import React from 'react';
import { Modal, Form } from 'antd';
import {
  modalActionTypes,
  modalTypes,
  useModalDispatch,
  useModalState,
} from '../../../../../shared/lib/toggleModalVisble';
import { useShutdownDescChange } from '../../api';
import { ShutdownField } from '../../../common/ui/ShutdownField';
import {
  fieldNames,
  changeModalWithInfoBodyStyle,
} from '../../../common/config';
import NotificationSendingAlert, {
  notificationSendingAlertMsgTypes,
} from '../../../../../shared/ui/NotificationSendingAlert/NotificationSendingAlert';

const ModalContainer = ({ form }) => {
  const { type, initialValues: shutdown = {} } = useModalState();
  const dispatch = useModalDispatch();

  const close = () => dispatch({ type: modalActionTypes.resetModalData });

  const { change, loading } = useShutdownDescChange();

  const { validateFieldsAndScroll } = form;

  const handleSubmit = () => {
    validateFieldsAndScroll(async (err, formValues) => {
      if (!err) {
        const data = { value: formValues.description.trim() };
        await change({ shutdownId: shutdown.alertId, data });
        close();
      }
    });
  };

  return (
    <Modal
      visible={type === modalTypes.changeShutdownDesc}
      onCancel={close}
      onOk={handleSubmit}
      title={`${
        shutdown.description?.trim() ? 'Изменить' : 'Добавить'
      } описание`}
      destroyOnClose
      confirmLoading={loading}
      bodyStyle={changeModalWithInfoBodyStyle}
    >
      <NotificationSendingAlert
        messageType={notificationSendingAlertMsgTypes.all}
      />
      <Form colon={false}>
        <ShutdownField
          name={fieldNames.description}
          form={form}
          initialValue={shutdown.description}
          editMode
        />
      </Form>
    </Modal>
  );
};

const ChangeModal = Form.create({ name: 'change_shutdown_desc' })(
  ModalContainer
);

export default ChangeModal;
